module.exports = __webpack_public_path__ + "static/media/emily-willis.7193e3be.jpg";